export class NoveltyModel {
    noveltyId?: number;
    title: string;
    begDate: string;
    endDate: string;
    visibleEttChk: boolean;
    visibleRpsChk: boolean;
    visibleVexChk: boolean;
    visibleTechChk: boolean;
    visibleProfChk: boolean;
    visibleFunChk: boolean;
    visibleRpoChk: boolean;
    url?: string;
    attachedName?: string;
    fileContent?: number[];
    iDate: string;
}

export class NoveltyResponseModel {
    novelties: NoveltyModel[];
    novelty: NoveltyModel;
    status: boolean;
    urlAttachment: string;
}

export class NoveltyUserModel {
    noveltyIds: number[];
}